import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ACSApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { ClientSummaryOverviewDto } from '../../../commonTypes/client.types';
import { setCachedClientSummaryOverview, selectCachedClientSummaryOverview } from '../../../store/slices/clients.slice';

const useHttpGetClientSummaryOverview = (clientId: string, month: string, year: number) => {
    const acsApi: ACSApi = useContainer(ACSApi);
    const dispatch = useDispatch();
    const cacheKey = `${clientId}-${month}-${year}`;
    const cachedData = useSelector(selectCachedClientSummaryOverview(cacheKey));
    const [isReady, setIsReady] = useState(false);
    const [data, setData] = useState<ClientSummaryOverviewDto[]>([]);

    useEffect(() => {
        if (!clientId || !month || !year) {
            setIsReady(true);
            setData([]);
            return;
        }

        if (cachedData) {
            setData(cachedData);
            setIsReady(true);
            return;
        }

        setIsReady(false);
        const { exec, abort } = acsApi.getClientSummaryOverview({
            params: { clientId },
            query: { month, year },
            onSuccess: res => {
                dispatch(setCachedClientSummaryOverview({ key: cacheKey, data: res.body }));
                setData(res.body);
            },
            onError: error => console.error('Error fetching client summary overview:', error),
            onFinally: () => setIsReady(true),
        });
        exec();
        return abort;
    }, [clientId, month, year]);

    return { isReady, data };
};

export default useHttpGetClientSummaryOverview;
